export default function KanbasNavigation() {
  return (
    <ul id="wd-kanbas-navigation">
      <li>
        <a id="wd-account-link" href="#/Kanbas/Account">
          Account
        </a>
      </li>
      <li>
        <a id="wd-dashboard-link" href="#/Kanbas/Dashboard">
          Dashboard
        </a>
      </li>
      <li>
        <a id="wd-course-link" href="#/Kanbas/Courses">
          Courses
        </a>
      </li>
      <li>
        <a id="wd-calendar-link" href="#/Kanbas/Calendar">
          Calendar
        </a>
      </li>
      <li>
        <a id="wd-inbox-link" href="#/Kanbas/Inbox">
          Inbox
        </a>
      </li>
      <li>
        <a id="wd-labs-link" href="#/Labs">
          Labs
        </a>
      </li>
    </ul>
  );
}
